import React, { useEffect } from 'react';
import { Modal } from "antd";
import closePng from "assets/images/home/closePng.png";

let scrollTop = 0;
const CommonModal = (props) => {
    const { width, title, isShowModal, children, mask, onOk, onClose, closable, closeModalBtn, minWidth, destroyOnClose, commonModal, zIndex = 1001 } = props;

    const renderCloseIcon = () => {
      return (
        <div className={closeModalBtn || "closeModalBtn"} style={{ backgroundImage: `url(${closePng})` }}></div>
      )
    }

    useEffect(()=>{
      if(destroyOnClose) return;
      if (isShowModal) {
        // 使body脱离文档流
        scrollTop = document.documentElement.scrollTop;
        document.body.classList.add('at-frozen');
        // 把脱离文档流的body拉上去！否则页面会回到顶部！
        document.body.style.top = `${-scrollTop}px`;
      } else {
        document.body.style.top = null;
        document.body.classList.remove('at-frozen');
        document.documentElement.scrollTop = scrollTop;
      }
      
      return () => {
        document.body.style.top = null;
        document.body.classList.remove('at-frozen');
        document.documentElement.scrollTop = scrollTop;
      }
    },[isShowModal])

    return (
        <>
            <Modal zIndex={zIndex} destroyOnClose={destroyOnClose} style={{minWidth: minWidth}} wrapClassName={commonModal ? commonModal : 'commonModal'} width={width} title={title} open={isShowModal} onOk={onOk} onCancel={onClose} mask={mask} footer={false} closeIcon={renderCloseIcon()} closable={closable} centered={true}>
                {children}
            </Modal>
        </>
    );
};

export default CommonModal;
